import { render, staticRenderFns } from "./teacherIndex.vue?vue&type=template&id=436f9e72&scoped=true&"
import script from "./teacherIndex.vue?vue&type=script&lang=js&"
export * from "./teacherIndex.vue?vue&type=script&lang=js&"
import style0 from "./teacherIndex.vue?vue&type=style&index=0&id=436f9e72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436f9e72",
  null
  
)

export default component.exports